export default "__VITE_ASSET__DBL9ZXIc__"